module.exports = __webpack_public_path__ + "img/pg5-fig2-table.86b39a71.png";